const getPostLink = slug => `/blog${slug}`

const links = {
  BLOG: '/blog',
  POST: {
    INTRODUCTION: getPostLink('/decentralized-platforms'),
  },
  MY_WEBSITE: "https://dillionmegida.com"
}

export default links
